<template>
  <div class="">
    <div class="container">
      <h2 class="header-font text-center">About the instructor</h2>
      <div class="grid">
        <div class="img">
          <img
            src="../../assets/bongo/seeam-color 1.png"
            alt=""
            style="background-color: #FBBF05;border-radius:50%"
          />
        </div>
        <div class="text">
          <h3>
            Sashoto Seeam
          </h3>
          <h4>
            UX Researcher & Product Designer
          </h4>
          <p>
            Sashoto Seeam is a Product Designer & UX Researcher. Since 2014, he
            has been involved with designing digital products, which are being
            used by millions of people. He believes firmly in data-informed
            design and loves to craft solutions that align user needs with
            business goals. Currently, he is working as a freelance consultant.
          </p>

          <div>
            <button @click="red" class="btn-1" ref="btnToggle">
              Show More
            </button>
            <span v-if="readmore">
              <h4 class="span-h4">
                Sashoto Seeam is a Product Designer & UX Researcher. Since 2014,
                he has been involved with designing digital products, which are
                being used by millions of people. He believes firmly in
                data-informed design and loves to craft solutions that align
                user needs with business goals. Currently, he is working as a
                freelance consultant. Most recently he was leading the design
                team of a British Agency named Compuco, which builds enterprise
                solutions for large NGOs and Nonprofits around the world;
                including Wikimedia, Scotland Police, World Heart Foundation,
                etc. Prior to that, he was a known face in the Bangladeshi tech
                and startup ecosystem. He helped to shape the product design org
                and lead the design team at Pathao for 2 years. He also worked
                on projects like ShopUp, CMED, Repto as well as in large
                conglomerates like Bashundhara Group. He is also active in the
                local community as a regular speaker and organizer of various
                design and product-related events. He was the creator of "Design
                Protidin", one of the first design-only content publishers in
                Bangladesh.
              </h4>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      readmore: false,
    }
  },
  methods: {
    red() {
      this.readmore = !this.readmore
      this.$refs.btnToggle.innerText = this.readmore ? 'Hide More' : 'Show More'
    },
  },
}
</script>

<style scoped>
.btn-1 {
  background-color: white;
  border: none;
  color: #2465f3;
  padding: 7px 30px;
  cursor: pointer;
  font-size: 16px;
  font-family: 'Manrope';
  font-weight: 700;
}
.span-h2 {
  padding-top: 20px;
  font: 700 1.5rem/1rem 'Manrope';
  color: white;
}
.span-h4 {
  padding: 20px 0;
  font: 400 0.75rem/1rem 'Manrope';
  color: white;
}
.img img {
  margin: 65px 130px;
  border: none;
}
.grid {
  max-width: 1300px;
  margin: 0 auto;
  background-color: #d21e28;

  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
}
.header-font {
  padding-top: 70px;
  font: 800 2.25rem/2.75rem 'Manrope';
  color: #29292b;
  padding-bottom: 50px;
}
.text {
  padding-top: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.text h3 {
  font: 700 1.5rem/1.75rem 'Manrope';
  color: white;
}
.text h4 {
  font: 700 0.875rem/1rem 'Manrope';
  color: #ececec;
}
.text p {
  font: 400 0.875rem/1.1rem 'Manrope';
  color: white;
}
ul li {
  font: 400 0.875rem/1rem 'Manrope';
  color: #d7eefd;
}
@media only screen and (max-width: 600px) {
  .img img {
    display: flex;
    margin: 25px auto;
    border: none;
  }
  .grid {
    max-width: 1300px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    grid-template-columns: 1fr;
  }
  .text {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 20px 40px;
  }
}
</style>
